!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return i = {}, o.m = c = {
    0: function (e, t) {
      e.exports = r;
    },
    1: function (e, t) {
      e.exports = n;
    },
    709: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var t = r(0),
        n = r.n(t),
        t = r(1),
        r = r.n(t),
        t = function (e) {
          var t = e.color,
            e = e.fillRule;
          return n.a.createElement("path", {
            fill: t,
            fillRule: e,
            d: "M1.413 21.19a1.406 1.406 0 1 0 0 2.81h14.088a1.406 1.406 0 1 0 0-2.81H1.413zm15.22-11.237a1.11 1.11 0 0 0-1.57 0l-5.51 5.51V1.11a1.111 1.111 0 0 0-2.221 0v14.351l-5.435-5.434a1.11 1.11 0 1 0-1.571 1.57l7.33 7.332c.026.026.054.05.082.074l.04.03c.016.01.031.024.047.035.017.01.033.019.049.03a.79.79 0 0 0 .045.025c.016.01.033.017.05.025l.048.022c.016.007.033.012.05.018l.053.019.05.013c.018.003.036.01.055.013.02.003.039.005.058.009l.05.007c.072.007.146.007.219 0l.049-.007c.019-.004.039-.005.058-.01l.055-.012.05-.013.053-.019a.429.429 0 0 0 .098-.04l.05-.025c.016-.008.03-.018.045-.026.017-.01.033-.018.049-.03.016-.01.032-.023.047-.034l.04-.03a1.39 1.39 0 0 0 .117-.113l.039-.035 7.331-7.331a1.112 1.112 0 0 0 0-1.572z"
          });
        };
      t.svg = {
        viewBox: "0 0 17 24"
      };
      var o = r()(t);
    }
  }, o.c = i, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 709);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return c[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var c, i;
});